import React, { useCallback, useRef, useState } from 'react';

const filter_boolean_input = [
	'eq',
	'in',
	'ne'
];

const filter_date_input = [
	'eq',
	'gt',
	'gte',
	'in',
	'lt',
	'lte',
	'ne'
];

const filter_number_input = [
	'eq',
	'gt',
	'gte',
	'in',
	'lt',
	'lte',
	'ne'
];

const filter_string_input = [
	'eq',
	'gt',
	'gte',
	'in',
	'lt',
	'lte',
	'like',
	'ne'
];

const subject_filter = [
	{ field: 'age', input: filter_number_input, label: 'Age' },
	{ field: 'alcohol_use_frequency', input: filter_string_input, label: 'Alcohol Use Frequency' },
	{ field: 'bmi', input: filter_number_input, label: 'BMI' },
	{ field: 'ccid', input: filter_number_input, label: 'CCID' },
	{ field: 'created_at', input: filter_date_input, label: 'Created At' },
	{ field: 'crid', input: filter_number_input, label: 'CRID' },
	{ field: 'date_of_birth', input: filter_date_input, label: 'Date Of Birth' },
	{ field: 'diet_type', input: filter_string_input, label: 'Diet Type' },
	{ field: 'email_address', input: filter_string_input, label: 'Email Address' },
	{ field: 'ethnicity', input: filter_string_input, label: 'Ethnicity' },
	{ field: 'first_name', input: filter_string_input, label: 'First Name' },
	{ field: 'full_name_first', input: filter_string_input, label: 'Full Name First' },
	{ field: 'full_name_last', input: filter_string_input, label: 'Full Name Last' },
	{ field: 'gender', input: filter_string_input, label: 'Gender' },
	{ field: 'height_in', input: filter_number_input, label: 'Height In' },
	{ field: 'id', input: filter_number_input, label: 'ID' },
	{ field: 'last_name', input: filter_string_input, label: 'Last Name' },
	{ field: 'lifestyle_notes', input: filter_string_input, label: 'Lifestyle Notes' },
	{ field: 'marital_status', input: filter_string_input, label: 'Marital Status' },
	{ field: 'middle_name', input: filter_string_input, label: 'Middle Name' },
	{ field: 'next_appt', input: filter_date_input, label: 'Next Appt' },
	{ field: 'phone_number', input: filter_string_input, label: 'Phone Number' },
	{ field: 'physical_activity_level', input: filter_string_input, label: 'Physical Activity Level' },
	{ field: 'preferred_language', input: filter_string_input, label: 'Preferred Language' },
	{ field: 'q_currently_in_clinical_trial', input: filter_boolean_input, label: 'Currently In Clinical Trial' },
	{ field: 'q_date_of_last_dose', input: filter_date_input, label: 'Date Of Last Dose' },
	{ field: 'q_date_of_last_visit', input: filter_date_input, label: 'Date Of Last Visit' },
	{ field: 'q_ever_in_clinical_trial', input: filter_boolean_input, label: 'Ever In Clinical Trial' },
	{ field: 'race', input: filter_string_input, label: 'Race' },
	{ field: 'ready_to_contact', input: filter_boolean_input, label: 'Ready To Contact' },
	{ field: 'recruitment_source_name', input: filter_string_input, label: 'Recruitment Source Name' },
	{ field: 'sleep_hours', input: filter_number_input, label: 'Sleep Hours' },
	{ field: 'smoker_status', input: filter_string_input, label: 'Smoker Status' },
	{ field: 'stress_level', input: filter_string_input, label: 'Stress Level' },
	{ field: 'title', input: filter_string_input, label: 'Title' },
	{ field: 'updated_at', input: filter_date_input, label: 'Updated at' },
	{ field: 'weight_lb', input: filter_number_input, label: 'Weight (lbs)' }
];

const subject_allergies_filter = [
	{ field: 'allergy_id', input: filter_number_input, label: 'Allergy ID' },
	{ field: 'allergy_id_allergen_description', input: filter_string_input, label: 'Allergen Description' },
	{ field: 'allergy_id_allergen_type', input: filter_string_input, label: 'Allergen Type' },
	{ field: 'allergy_id_description', input: filter_string_input, label: 'Allergy Description' },
	{ field: 'allergy_id_name', input: filter_string_input, label: 'Allergy Name' },
	{ field: 'allergy_type', input: filter_string_input, label: 'Allergy Type' },
	{ field: 'allergy_id_cc_allergen_id', input: filter_number_input, label: 'CC Allergen ID' },
	{ field: 'allergy_id_ccid', input: filter_number_input, label: 'CCID' },
	{ field: 'created_at', input: filter_date_input, label: 'Created at' },
	{ field: 'allergy_name', input: filter_string_input, label: 'Custom Allergy Name' },
	{ field: 'id', input: filter_number_input, label: 'ID' },
	{ field: 'notes', input: filter_string_input, label: 'Notes' },
	{ field: 'reaction', input: filter_string_input, label: 'Reaction' },
	{ field: 'severity', input: filter_string_input, label: 'Severity' },
	{ field: 'subject_id', input: filter_number_input, label: 'Subject ID' },
	{ field: 'updated_at', input: filter_date_input, label: 'Updated at' }
];

const fieldGroups = {
	Subject: subject_filter,
	Allergies: subject_allergies_filter
	// FIXME: Add the rest of the related tables
};

const find_filter = field => {
	for (let group of Object.keys(fieldGroups)) {
		const found = fieldGroups[group].find(f => f.field === field);
		if (found) return found;
	}
};

const getFieldType = (field) => {
	const config = find_filter(field);
	if (!config) return 'string';

	if (config.input === filter_number_input) return 'number';
	if (config.input === filter_boolean_input) return 'boolean';
	if (config.input === filter_date_input) return 'date';

	return 'string';
};

const normalizeValue = (field, rawValue) => {
	if (rawValue === '' || rawValue === null || rawValue === undefined) {
		return rawValue;
	}

	const type = getFieldType(field);

	switch (type) {
		case 'number': {
			const num = Number(rawValue);
			return isNaN(num) ? rawValue : num;
		}

		case 'boolean': {
			if (rawValue === true || rawValue === false) return rawValue;
			if (rawValue === 'true') return true;
			if (rawValue === 'false') return false;
			return rawValue;
		}

		case 'date': {
			// Keep ISO string but ensure valid
			const date = new Date(rawValue);
			return isNaN(date.getTime()) ? rawValue : date.toISOString();
		}

		default:
			return rawValue;
	}
};


const is_blank = value => {
	if (value === null || value === undefined) return true;
	if (typeof value === 'string') return value.trim() === '';
	if (Array.isArray(value)) return value.every(is_blank);
	if (typeof value === 'object') return is_blank_object(value); // recursive
	return false;
};

const is_blank_object = obj => {
	if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) return false;
	return Object.entries(obj).every(([key, value]) => {
		const key_is_blank = key.trim() === '';
		return key_is_blank && is_blank(value);
	});
};

// Convert UI filters to json (i.e. studies.subject_inclusion_filters_json)
const filters_to_json = (filters) => {
	if (!Array.isArray(filters)) return null;

	const row = {};

	for (const { field, operator, value } of filters) {
		if (!field || !operator || is_blank(value)) continue;

		if (!row[field]) {
			row[field] = {};
		}

		row[field][operator] = value;
	}

	// If nothing valid, return null
	if (Object.keys(row).length === 0) return null;

	// One OR row for now
	return [row];
};


// Convert json (i.e. studies.subject_inclusion_filters_json) to UI filters
const json_to_filters = json => {
	const filters = [];
	// Each row is an OR -- FIXME: Will probably use a separate FilterCreator for each OR
	for (let row of (json || [])) {
		for (let field of Object.keys(row)) {
			for (let operator of Object.keys(row[field])) {
				filters.push({
					field,
					operator,
					value: row[field][operator]
				});
			}
		}
		// Only a single row for now
		break;
	}
	return filters;
};

export default ({ get, set }) => {
	const isConstructed = useRef(false);
	const [filters, setFilters] = useState([]);

	if (!isConstructed.current) {
		isConstructed.current = true;
		let json = get();
		try {
			if (typeof json === 'string') json = JSON.parse(json);
		} catch (error) {
			console.error(error);
		}
		const filters = json_to_filters(json);
		setFilters(filters);
	}

	const updateFilter = useCallback((index, key, value) => {
		const updated = [...filters];

		if (key === 'value') {
			const field = updated[index].field;
			updated[index][key] = normalizeValue(field, value);
		} else {
			updated[index][key] = value;
		}

		setFilters(updated);
		const json = filters_to_json(updated);
		set && set(json);
	}, [JSON.stringify(filters)]);


	const addFilter = useCallback(() => {
		const updated = [...filters, { field: '', operator: '', value: '' }];
		setFilters(updated);
		const json = filters_to_json(updated);
		console.log('json', json);
		set && set(json);
	}, [JSON.stringify(filters)]);

	const removeFilter = useCallback(index => {
		const updated = filters.filter((_, i) => i !== index);
		setFilters(updated);
		const json = filters_to_json(updated);
		console.log('json', json);
		set && set(json);
	}, [JSON.stringify(filters)]);

	const renderFieldOptions = () => {
		return Object.entries(fieldGroups).map(([groupLabel, fields]) => (
			<optgroup label={groupLabel} key={groupLabel}>
				{fields.map(({ field, label }) => (
					<option key={field} value={field}>
						{label}
					</option>
				))}
			</optgroup>
		));
	};

	return (
		<div className="container">
			{filters.map((filter, index) => (
				<div className="row g-2 align-items-center mb-3" key={index}>
					<div className="col-md-5">
						<select
							className="form-select"
							value={filter.field}
							onChange={(e) => updateFilter(index, "field", e.target.value)}
						>
							<option value="">Select field</option>
							{renderFieldOptions()}
						</select>
					</div>

					<div className="col-md-2">
						<select
							className="form-select"
							value={filter.operator}
							onChange={(e) => updateFilter(index, "operator", e.target.value)}
						>
							<option value="">Op</option>
							{find_filter(filter.field)?.input.map((op) => (
								<option key={op} value={op}>
									{op}
								</option>
							))}
						</select>
					</div>

					<div className="col">
						<input
							type="text"
							className="form-control"
							placeholder="Value"
							value={filter.value}
							onChange={(e) => updateFilter(index, "value", e.target.value)}
						/>
					</div>

					<div className="col-auto text-end">
						<button
							type="button"
							className="btn btn-outline-danger"
							onClick={() => removeFilter(index)}
						>
							&times;
						</button>
					</div>
				</div>
			))}

			<div className="text-start">
				<button className="btn btn-secondary" onClick={addFilter}>
					{Object.keys(filters).length === 0 ? 'Add a Filter' : 'Add Another Filter'}
				</button>
			</div>
		</div>
	);
};
